class LogShippingTokenLimitsModelManipulator {
    isLastEnabledToken(numOfEnabledTokens) {
        return numOfEnabledTokens === 1;
    }
    getRemainingTokens(limits) {
        return limits?.maxAllowedTokens - limits?.numOfEnabledTokens;
    }
}
export const logShippingTokenLimitsModelManipulator = new LogShippingTokenLimitsModelManipulator();
//# sourceMappingURL=log-shipping-token-limits.manipulator.js.map